import * as React from 'react';
import * as style from '../textReviewsNew.module.scss';
import { styled } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

export const TextReviewCard = ({ data, eng }) => {
  const [isFullText, setIsFullText] = React.useState(false);
  const isMobile = useMediaQuery('(max-width:767px)');

  const StyledButton = styled('button')({
    marginTop: isMobile ? '10px' : '20px',
    padding: 0,
    textAlign: 'left',
    color: '#343A40',
    opacity: '0.5',
    fontWeight: '400',
    fontSize: '1em',
    lineHeight: '130%',
    position: 'relative',
  });

  return (
    <div className={style.textReviewContainer}>
      <div className={style.student__info}>
        {
          data.avatar ?
            <img
              src={data.avatar}
              alt={""}
              className={style.student__img}
            />
            :
            null
        }
        <div className={style.student__wrapper}>
          <p className={style.student__name}>{data.author}</p>
          {
            data.extra ?
              <p className={style.student__extra}>{data.extra}</p>
              :
              null
          }
        </div>
      </div>
      <p className={style.studentReview}>
        {data.visibleText}
        {data.hiddenText &&
          (isFullText ? (
            <>
              {data.hiddenText}
              <br />
              <StyledButton
                onClick={() => {
                  setIsFullText(false);
                }}
              >
                Скрыть текст
              </StyledButton>
            </>
          ) : (
            <>
              ...
              <br />
              <StyledButton
                onClick={() => {
                  setIsFullText(true);
                }}
              >
                {
                  eng ? `Read full review\u00A0»` : "Читать полностью\u00A0»"
                }
              </StyledButton>
            </>
          ))}
      </p>
    </div>
  );
};
